import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../data.service';
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-crearcontrasena',
  templateUrl: './crearcontrasena.component.html',
  styleUrls: ['./crearcontrasena.component.css']
})
export class CrearcontrasenaComponent {
  passwordForm: FormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  id: string;
  visible:boolean = false;

  constructor(private fb: FormBuilder, private data: DataService, private route: ActivatedRoute, private router: Router, private messageService: MessageService) {
    //obtetenr el id de la url
    this.id = this.route.snapshot.paramMap.get('id');

    this.passwordForm = this.fb.group({
      Nombre: ['', [Validators.required]],
      Email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      Clave: ['', [Validators.required, Validators.minLength(6)]],
      confirmClave: ['', [Validators.required]]
    }, { validator: this.passwordsMatchValidator });
  }

  ngOnInit() {
    if (this.id) {
      
      console.log("Consultando usuario con id:", this.id);
      this.data.PreCrearClave(this.id).subscribe({
        next: (x) => {
          this.visible = true;
          console.log("PreCrearClave - Datos recibidos:", x);
          this.passwordForm.patchValue({
            Nombre: x.Nombre,
            Email: x.Email
          });
        },
        error: (error) => {
          this.visible = false;
          console.error("Error en PreCrearClave:", error);
          this.messageService.add({severity:'error', summary: 'Error', detail: 'El usuario no existe o ya ha creado su contraseña.'});
        }
      });
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  passwordsMatchValidator(form: FormGroup) {
    return form.get('Clave')?.value === form.get('confirmClave')?.value
      ? null : { mismatch: true };
  }

  async onSubmit() {
    if (this.passwordForm.valid) {
      console.log('Formulario enviado:', this.passwordForm.value);
      this.passwordForm.value._id = this.id;
      this.data.CrearClave(this.passwordForm.value).subscribe(response => {
        console.log('Clave creada:', response);
        this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Clave creada exitosamente'});
        //redireccionar a la página de login
        this.router.navigate(['/']);
      }, error => {
        console.error('Error al crear la clave:', error);
      });
    } else {
      console.log('Formulario no válido');
    }
  }

  get controls() {
    return this.passwordForm.controls;
  }
}

